// views/auth/login.js  (PT-BR)
export const login_i18n = {
  panelKicker: "WACHECKIN · 2026",
  panelCta: "Conheça o WACheckin",
  partnersLabel: "Conectado com",
  // Os cartões da cena do painel.
  escena: {
    reservas: "Reservas",
    mensajes: "Mensagens automáticas",
    llaves: "Chaves digitais",
    checkin: "Check-in online",
    cobros: "Cobranças automáticas",
    autoridades: "Autoridades e conformidade",
  },

  // Passo 2: o código que chega por e-mail.
  verify: {
    title: "Confira seu e-mail",
    titleWhatsapp: "Confira seu WhatsApp",
    sending: "Enviando…",
    destinoWhatsapp: "Vai chegar no",
    destinoCorreo: "Vai chegar em",
    intro: "Enviamos um código de {largo} dígitos para",
    submit: "Entrar",
    submitting: "Verificando...",
    back: "Usar outra conta",
    resendAsk: "Não chegou?",
    resend: "Reenviar código",
    resendWait: "Reenviar em {s} s",
    resendDone: "Enviamos um novo código.",
    expires: "O código expira em {tiempo}",
    expired: "O código expirou. Peça um novo.",
    digitAria: "Dígito {n} de {total}",
    otroMetodo: "Não chegou o e-mail?",
    porWhatsapp: "Receba pelo WhatsApp",
    preferesCorreo: "Prefere o e-mail?",
    porCorreo: "Receba por e-mail",
    introWhatsapp: "Enviamos um código de {largo} dígitos pelo WhatsApp para",
    enviadoWhatsapp: "Enviamos o código pelo WhatsApp.",
  },
  langLabel: "Idioma",
  panelTitle: "Todas as suas acomodações automatizadas com IA",
  panelDesc:
    "Check-in, mensagens, chaves, cobranças e autoridades. Um único painel para tudo.",

  bannerAlt: "fundo de login",
  brandAlt: "WA Checkin",
  footerLogoAlt: "WA Checkin",
  togglePasswordAria: "mostrar ou ocultar a senha",

  title: "Bem-vindo de volta!",
  infoTitle: "Se você já tem uma conta, entre com seu e-mail.",
  infoDesc: "Se ainda não tem conta, você pode se cadastrar no final.",

  emailLabel: "E-mail",
  emailPlaceholder: "Digite seu e-mail",

  passwordLabel: "Senha",
  passwordPlaceholder: "Digite sua senha",

  forgot: "Esqueceu sua senha?",

  submit: "Entrar",
  submitting: "Entrando...",

  noAccount: "Não tem uma conta?",
  signup: "Cadastre-se",

  terms: "Termos",
  privacy: "Política de privacidade",
  copyright: "© 2024–{anio} WA Checkin. Todos os direitos reservados.",

  resetSuccess: "Enviamos um e-mail para você recuperar sua senha.",

  errors: {
    default: "Não foi possível entrar.",
    network: "Erro de conexão. Tente novamente.",
  },

  resetPassword: {
    title: "Recuperar senha",
    infoTitle: "Vamos enviar um link por e-mail",
    infoDesc: "Digite seu e-mail e você receberá as instruções para redefinir sua senha.",
    labels: { email: "Endereço de e-mail" },
    placeholders: { email: "nome@email.com" },
    hints: { email: "Use o e-mail com o qual você se cadastrou." },
    buttons: { send: "Enviar", sending: "Enviando..." },
    successTitle: "Pronto!",
    successDesc: "Confira sua caixa de entrada (e o spam).",
    aria: { close: "fechar" },
    toasts: {
      emailRequired: "Digite seu e-mail.",
      sent: "Enviamos o e-mail com as instruções.",
      userNotFound: "Usuário não cadastrado.",
      networkError: "Erro de conexão. Tente novamente.",
    },
  },
  common: { ok: "Entendi", cancel: "Fechar" },
};
